import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';

// TS port of the source (Falah) app's pages/reports/announcements/ActiveAnnouncementsReport.jsx
// — ported as-is (generic module).
const STATUS_OPTIONS: ReportOption[] = [
  { value: 'normal', label: 'Normal' },
  { value: 'important', label: 'Important' },
  { value: 'urgent', label: 'Urgent' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'title', label: 'Title' },
  { key: 'priority', label: 'Priority' },
  { key: 'published_at', label: 'Published' },
  { key: 'expires_at', label: 'Expires' },
  { key: 'days_left', label: 'Days Left' },
  { key: 'author', label: 'Author' },
];

export function ActiveAnnouncementsReport() {
  return (
    <ReportView
      title="Active Announcements"
      description="Announcements currently live (published and not yet expired)."
      endpoint="/reports/announcements/active"
      columns={COLUMNS}
      filters={['status']}
      statusOptions={STATUS_OPTIONS}
    />
  );
}
